export const ActionsDefaultState = {
	send: "Отправить заявку",
	revoke: "Отозвать заявку",
	comment: "Комментарий",
	lastComment: "Последний комментарий",
	writtenReply: "Письменный ответ",
	respondRequest: "Ответить",
	question: "Требуется уточнение",
	visible: ["send", "revoke"],
};

/*
 Status:
 0 - Черновик
 14 - На проверке
 18 - На согласовании
 7 - Отправлено
 19 - Ответ Администратора
 */

export const ActionsRules = {
	user: {
		0: {
			send: "Отправить анкету на согласование",
			visible: ["send", "personal/send"],
			comment: "Согласие на обработку персональных данных",
			lastComment: null,
		},
		14: {
			...ActionsDefaultState,
			visible: [],
		},
		18: {
			send: "Согласовать",
			revoke: "Отказаться",
			comment: {
				revoke: "Причина отказа",
				send: "Данные согласующего",
			},
			commentTitle: "Пожалуйста, поясните причину отказа",
			lastComment: "Что изменилось в анкете?",
			lastCommentColor: "#ff5050",
			visible: [...ActionsDefaultState.visible, "personal/revoke", "personal/send", "comment/revoke"],
			showOnLoad: true,
			mainPageAlert: `Уважаемый участник<br /><br />
        В анкету были внесены изменения с целью приведения данных по компаниям-участникам Фонда “Сколково” к единообразию.<br /><br />
        Просим ознакомиться и согласовать изменения.`,
		},
		19: {
			send: "Письменный ответ",
			showOnLoad: true,
			commentTitle: "Письменный ответ",
		},
		20: {
			send: "Требуется уточнение",
			showOnLoad: true,
			commentTitle: "Требуется уточнение",
		},
		7: {
			visible: [],
		},
	},
	verificator: {
		0: {
			...ActionsDefaultState,
			visible: [],
		},
		14: {
			send: "Опубликовать",
			revoke: "Вернуть на согласование",
			comment: "Что изменилось в анкете?",
			lastComment: "Комментарий компании участника",
			lastCommentColor: "#50abff",
			revokeColor: "#ff5050",
			visible: [...ActionsDefaultState.visible, "comment/revoke"],
		},
		18: {
			...ActionsDefaultState,
			visible: [],
		},
		7: {
			...ActionsDefaultState,
			visible: [],
		},
	},
};
